<template>
    <div class="examIndex">
        <!-- <div class="examIndex_back" @click="router.replace('/examStu/myExam')">
            返回
        </div> -->
        <div class="examIndex_box">
            <div class="examIndex_box_info">
                <div class="examIndex_box_info_box">
                    <!-- <div class="examIndex_box_title">{{examInfo.exam_name}}</div> -->
                    <div class="examIndex_box_examTime">开放时间：{{ examInfo.exam_startTime }} ~ {{ examInfo.exam_endTime }}</div>
                    <div class="examIndex_box_examInfo">
                        <div class="examIndex_box_examInfo_left">
                            <div class="examIndex_box_examInfo_item"><img src="@img/examStu/examInfo1.png" alt="">总分：<span>{{examInfo.exam_totalScore}}分</span></div>
                            <div class="examIndex_box_examInfo_item"><img src="@img/examStu/examInfo2.png" alt="">及格分：<span>{{examInfo.exam_passScore}}分</span></div>
                            <div class="examIndex_box_examInfo_item"><img src="@img/examStu/examInfo3.png" alt="">题目数量：<span>{{examInfo.exam_quesNum}}题</span></div>
                        </div>
                        <div class="examIndex_box_examInfo_right">
                            <div class="examIndex_box_examInfo_item"><img src="@img/examStu/examInfo4.png" alt="">答题时间：<span>{{examInfo.exam_time}}分钟</span></div>
                            <div class="examIndex_box_examInfo_item"><img src="@img/examStu/examInfo5.png" alt="">参与人数：<span>{{examInfo.exam_num}}人</span></div>
                        </div>
                    </div>
                    <div class="examIndex_box_examNote" v-if="examInfo.exam_note">
                        <div class="examIndex_box_examNote_title">
                            <img src="@img/examStu/examInfo3.png" alt="">说明
                        </div>
                        <div class="examIndex_box_examNote_content">{{ examInfo.exam_note }}</div>
                    </div>
                </div>
                <div class="examIndex_box_button">
                    <el-button type="primary" @click="startExam">开始答题</el-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ElMessage } from 'element-plus/lib/components/index.js';
import { defineProps} from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter()

const props = defineProps({
    examInfo:{
        type:Object,
    },
    scene:{
        type:String,
        default:function(){
            return ''
        }
    },
    examres_name:{
        type:String,
        default:function(){
            return ''
        }
    },
    examres_phone:{
        type:String,
        default:function(){
            return ''
        }
    }


})

function startExam(){
    const startTime = new Date(props.examInfo.exam_startTime).getTime()
    const endTime = new Date().getTime() && new Date(props.examInfo.exam_endTime).getTime()
    const curTime = new Date().getTime()
    if( endTime > curTime && startTime < curTime){
        if(props.examInfo['exam_status'] == 3){
            return ElMessage.error('考试已完成，等待批阅！')
        }
        let jumpPath='/examStu/examination'
        let obj = {}
        if(props.scene == 'pub'){
            obj['isPub'] = true
            obj['examres_name'] = props.examres_name
            obj['examres_phone'] = props.examres_phone
            jumpPath='/pub'+jumpPath
        }
        router.push({
            path:jumpPath,
            query:{
                id:props.examInfo.examres_id,
                ...obj,
            }
        })
    }else if( new Date(props.examInfo.exam_startTime).getTime() > new Date().getTime()){
        return ElMessage.error('考试未开始')
    }else{
        return ElMessage.error('考试已结束')
    }
}


</script>

<style scoped lang="scss">
.examIndex{
    position: relative;
    width: 100%;
    height: 100%;
    background-color: #fff;
    .examIndex_back{
        position: absolute;
        top: 20px;
        left: 20px;
        cursor: pointer;
        font-size: 16px;
        line-height: 16px;
        color: #808080;
    }
    .examIndex_box{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        overflow: auto;
        .examIndex_box_info{
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 80%;
            max-width: 80%;
            height: 100%;
            min-height: 0;
            padding-bottom: 40px;
            box-sizing: border-box;
            .examIndex_box_info_box{
                display: flex;
                flex-direction: column;
                flex: 1;
                min-height: 0;
                overflow: hidden;
                /* .examIndex_box_title{
                    text-align: center;
                    font-size: 24px;
                    line-height: 1.3;
                    font-weight: 600;
                    color: #303033;
                } */
                .examIndex_box_examTime{
                    text-align: center;
                    margin-top: 14px;
                    font-size: 14px;
                    line-height: 24px;
                    color: #909099;
                    flex-shrink: 0;
                }
                .examIndex_box_examInfo{
                    width: 100%;
                    margin-top: 30px;
                    flex-shrink: 0;
                    display: flex;
                    background-color: #FAFAFA;
                    .examIndex_box_examInfo_left,
                    .examIndex_box_examInfo_right{
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        padding: 24px 12px;
                        font-size: 14px;
                        line-height: 24px;
                        color: #808080;
                        .examIndex_box_examInfo_item{
                            min-height: 40px;
                            display: flex;
                            align-items: center;
                            img{
                                width: 16px;
                                height: 16px;
                                margin-right: 12px;
                                flex-shrink: 0;
                            }
                            span{
                                color: #303033;
                            }
                        }
                    }
                }
                .examIndex_box_examNote{
                    flex: 1;
                    min-height: 0;
                    margin-top: 16px;
                    margin-bottom: 16px;
                    padding: 16px;
                    display: flex;
                    flex-direction: column;
                    background-color: #FAFAFA;
                    .examIndex_box_examNote_title{
                        display: flex;
                        align-items: center;
                        flex-shrink: 0;
                        font-size: 14px;
                        line-height: 24px;
                        color: #808080;
                        img{
                            width: 16px;
                            height: 16px;
                            margin-right: 12px;
                        }
                    }
                    .examIndex_box_examNote_content{
                        flex: 1;
                        min-height: 0;
                        margin-top: 12px;
                        padding: 0 4px 0 28px;
                        overflow-y: auto;
                        font-size: 14px;
                        line-height: 22px;
                        color: #303033;
                        white-space: pre-wrap;
                        word-break: break-word;
                        &::-webkit-scrollbar{
                            width: 6px;
                        }
                        &::-webkit-scrollbar-thumb{
                            background-color: #dcdfe6;
                            border-radius: 3px;
                        }
                    }
                }
                .examIndex_box_examDescripe{
                    flex-grow: 1;
                    padding-top: 18px;
                    display: flex;
                    justify-content: center;
                    flex-direction: column;
                    background-color: #FAFAFA;
                    margin-bottom: 16px;
                    .examIndex_box_examDescripe_title{
                        display: flex;
                        align-items: center;
                        font-size: 14px;
                        line-height: 24px;
                        color: #808080;
                        width: 50%;
                        justify-content: center;
                        img{
                            width: 16px;
                            height: 16px;
                            margin-right: 12px;
                        }
                    }
                    .examIndex_box_examDescripe_content{
                        flex-grow: 1;
                        margin-top: 18px;
                        div::-webkit-scrollbar{
                            width: 6px;
                            height: 6px;
                        }
                        div{
                            overflow: scroll;
                            height: 100%;
                            padding-left: 34px;
                            font-size: 14px;
                            color: #808080;
                            line-height: 18px;
                        }
                    }
                }
            }
            .examIndex_box_button{
                display: flex;
                align-items: center;
                justify-content: center;
                width: 100%;
                flex-shrink: 0;
            }

        }
    }
}
</style>